import {
    getFuelIdLoading,
    getFuelIdRequest,
    getFuelIdSuccess,
    getFuelIdReject,
} from "../../actions/fuel/getId";

export const getFuelId = (formData) => async (dispatch, getState) => {
    dispatch(getFuelIdLoading());
    try {
        const { data } = await getFuelIdRequest(formData, getState);
        dispatch(getFuelIdSuccess(data))
    } catch (error) {
        dispatch(getFuelIdReject(error))
    }
    return Promise.resolve();
};